import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";

import {AdSpecificationOptionResponse} from "@numizmat/services-models/nomenclature";

@Injectable({
  providedIn: 'root'
})
export class AdSpecificationOptionStateService {
  private allAdSpecificationOptions$: BehaviorSubject<{ [key: number]: AdSpecificationOptionResponse[] }> =
    new BehaviorSubject<{ [key: number]: AdSpecificationOptionResponse[] }>({});

  public getAdSpecificationOptions(adSpecificationId: number): Observable<AdSpecificationOptionResponse[] | undefined> {
    const currentAllAdSpecificationOptions = this.allAdSpecificationOptions$.getValue();
    return of(currentAllAdSpecificationOptions[adSpecificationId]);
  }

  public setAdSpecificationOptions(adSpecificationId: number, options: AdSpecificationOptionResponse[]): void {
    const currentAllAdSpecificationOptions = this.allAdSpecificationOptions$.getValue();
    currentAllAdSpecificationOptions[adSpecificationId] = options;
    this.allAdSpecificationOptions$.next({...currentAllAdSpecificationOptions});
  }
}
